// Application types

const PAYMENT = {
  LOADING_PAYMENT: "LOADING_PAYMENT",
  ALL_PAYMENT_PROVIDERS: "ALL_PAYMENT_PROVIDERS",
  MY_PAYMENT_INSTRUMENT: "MY_PAYMENT_INSTRUMENT",
  SINGLE_PAYMENT: "SINGLE_PAYMENT",
  FILTER_PAYMENT: "FILTER_PAYMENT",
  FILTERING_PAYMENT: "FILTERING_PAYMENT",
  LOADING_SEARCH: "LOADING_SEARCH",
  SEARCH_PAYMENT: "SEARCH_PAYMENT",
  DOWNLOADING: "DOWNLOADING",
  CREATING: "CREATING",
  DELETING: "DELETING",
  ALL_PAYMENT_NO_PAGINATION: "ALL_PAYMENT_NO_PAGINATION",
};

export default PAYMENT;
